if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form || !this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (!this.validateVariantSelection()) return;
        if (!this.validateRequestedQuantity()) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantInput = this.form.querySelector('[name=id]');
        this.skipCart = variantInput && variantInput.dataset.skipCart === 'true';
        
        (window.fetchCartWithRetry ? window.fetchCartWithRetry() : fetch(`${routes.cart_url}.js`).then((response) => {
            if (!response.ok) throw new Error(`Cart read HTTP error: ${response.status}`);
            return response.json();
          }))
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig()).then((response) => {
                if (!response.ok) throw new Error(`Upsell add HTTP error: ${response.status}`);
                return response;
              });
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Cart add HTTP error: ${response.status}`);
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              const submitButtonText = this.submitButton.querySelector('span');
              if (submitButtonText) submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error('Product form submission error:', error);
            this.handleErrorMessage('Impossible d’ajouter ce produit au panier. Veuillez réessayer.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
          });
      }
            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      validateVariantSelection() {
        const variantInput = this.form?.querySelector('[name="id"]');
        const variantId = variantInput?.value;

        if (!variantId || variantId === 'null') {
          this.showErrorMessage('⚠️ Veuillez sélectionner une taille/couleur avant de continuer.');
          return false;
        }

        if (variantInput.disabled) {
          variantInput.disabled = false;
        }

        return true;
      }

      validateRequestedQuantity() {
        const quantityInput = this.form?.querySelector('[name="quantity"]');
        const requestedQty = parseInt(quantityInput?.value || '1', 10);

       if (Number.isNaN(requestedQty) || requestedQty < 1) {
       this.showErrorMessage('⚠️ Veuillez choisir une quantité valide.');
        return false;
      }

  return true;
}

      showErrorMessage(message) {
        this.showProductFormNotice(message, 'product-form__error');
      }

      showPreorderWarning(message) {
        this.showProductFormNotice(message, 'product-form__preorder', 8000);
      }

      showProductFormNotice(message, className, timeout = 5000) {
        if (!message) return;
        const existingNotice = this.querySelector(`.${className}`);
        if (existingNotice) existingNotice.remove();

        const notice = document.createElement('div');
        notice.className = className;
        notice.setAttribute('role', className === 'product-form__error' ? 'alert' : 'status');
        notice.textContent = message;

        const buttons = this.querySelector('.product-form__buttons') || this.form;
        if (buttons?.parentElement) {
          buttons.parentElement.insertBefore(notice, buttons);
        } else {
          this.appendChild(notice);
        }

        window.setTimeout(() => notice.remove(), timeout);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
